<template>
  <div class="notifications-dropdown">

    <!-- HEADER -->

    <div class="dropdown-header">

      <div class="header-copy">
        <div class="header-title-row">

          <div class="header-icon">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              aria-hidden="true"
            >
              <path
                d="M6.8 9.5C6.8 6.4 8.8 4.5 12 4.5C15.2 4.5 17.2 6.4 17.2 9.5V13.2L18.7 15.5H5.3L6.8 13.2V9.5Z"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linejoin="round"
              />

              <path
                d="M9.8 18C10.3 18.8 11 19.2 12 19.2C13 19.2 13.7 18.8 14.2 18"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
              />
            </svg>
          </div>

          <div>
            <h3 class="header-title">
              Уведомления
            </h3>

            <p class="header-subtitle">
              Последние события вашего аккаунта
            </p>
          </div>

        </div>
      </div>


      <div
        v-if="!isLoading && notifications.length"
        class="notification-count"
      >
        {{ notifications.length }}
      </div>

    </div>


    <!-- CONTENT -->

    <div class="dropdown-content">

      <!-- SKELETON -->

      <div
        v-if="isLoading"
        class="skeleton-list"
      >
        <NotificationSkeleton
          v-for="n in 3"
          :key="`skeleton-${n}`"
          class="notification-skeleton"
        />
      </div>


      <!-- EMPTY -->

      <div
        v-else-if="notifications.length === 0"
        class="empty-state"
      >
        <div class="empty-icon-wrap">
          <img
            src="../assets/empty-notification-icon.png"
            alt=""
            class="empty-icon"
          />
        </div>

        <div class="empty-title">
          Всё спокойно
        </div>

        <p class="empty-text">
          Новых уведомлений пока нет
        </p>
      </div>


      <!-- NOTIFICATIONS -->

      <div
        v-else
        class="notifications-list"
      >
        <div
          v-for="item in notifications"
          :key="item.id"
          class="notification-item"
          @click="handleNotificationClick(item)"
        >

          <!-- ICON -->

          <div
            class="notification-icon-wrap"
            :class="`type-${item.type}`"
          >
            <img
              :src="getNotificationIcon(item.type)"
              alt=""
              class="notification-icon"
            />
          </div>


          <!-- TEXT -->

          <div class="notification-content">

            <div class="notification-top-row">

              <p class="notification-title">
                {{ getNotificationTitle(item.type) }}
              </p>

              <span class="notification-date">
                {{ formatDate(item.created_at) }}
              </span>

            </div>


            <p class="notification-description">
              {{ item.notification }}
            </p>

          </div>


          <!-- DELETE -->

          <button
            type="button"
            class="delete-notification-button"
            title="Удалить уведомление"
            aria-label="Удалить уведомление"
            @click.stop="deleteNotification(item)"
          >
            <svg
              viewBox="0 0 20 20"
              fill="none"
              aria-hidden="true"
            >
              <path
                d="M6.5 7V14"
                stroke="currentColor"
                stroke-width="1.4"
                stroke-linecap="round"
              />

              <path
                d="M10 7V14"
                stroke="currentColor"
                stroke-width="1.4"
                stroke-linecap="round"
              />

              <path
                d="M13.5 7V14"
                stroke="currentColor"
                stroke-width="1.4"
                stroke-linecap="round"
              />

              <path
                d="M4.8 5H15.2"
                stroke="currentColor"
                stroke-width="1.4"
                stroke-linecap="round"
              />

              <path
                d="M7.7 5V3.8H12.3V5"
                stroke="currentColor"
                stroke-width="1.4"
                stroke-linejoin="round"
              />

              <path
                d="M5.8 5L6.4 16H13.6L14.2 5"
                stroke="currentColor"
                stroke-width="1.4"
                stroke-linejoin="round"
              />
            </svg>
          </button>

        </div>
      </div>

    </div>

  </div>
</template>


<script setup>

import {
  ref,
  onMounted
} from "vue";

import {
  useRouter
} from "vue-router";

import NotificationService
  from "../api/NotificationService.js";

import NotificationSkeleton
  from "./NotificationSkeleton.vue";


const router =
  useRouter();


const notifications =
  ref([]);


const isLoading =
  ref(true);


onMounted(
  async () => {

    try {

      isLoading.value =
        true;


      notifications.value =
        await NotificationService
          .getUserNotifications();

    } catch (error) {

      console.error(
        "❌ Ошибка при загрузке уведомлений:",
        error
      );

    } finally {

      isLoading.value =
        false;

    }

  }
);


function getNotificationIcon(type) {

  switch (type) {

    case "friend_request":
    case "friend_accept":
      return "/notification_friend.png";


    case "new_chat":
    case "new_message":
      return "/notification_message.png";


    case "new_vacancy":
    case "new_response":
    case "weekly_newsletter":
      return "/notification_vac.png";


    case "chat_gpt":
      return "/notification_ai.png";


    default:
      return "/notification_bell.png";

  }

}


function getNotificationTitle(type) {

  switch (type) {

    case "friend_request":
      return "Запрос в друзья";


    case "friend_accept":
      return "Запрос принят";


    case "new_chat":
    case "new_message":
      return "Новое сообщение";


    case "new_response":
      return "Новый отклик";


    case "new_vacancy":
      return "Новая вакансия";


    case "weekly_newsletter":
      return "Подборка вакансий";


    case "chat_gpt":
      return "HYPER AI";


    default:
      return "Уведомление";

  }

}


function formatDate(dateValue) {

  if (!dateValue) {
    return "";
  }


  const date =
    new Date(dateValue);


  if (
    Number.isNaN(
      date.getTime()
    )
  ) {
    return "";
  }


  return date.toLocaleDateString(
    "ru-RU",
    {
      day: "numeric",
      month: "short"
    }
  );

}


async function deleteNotification(item) {

  if (!item?.id) {
    return;
  }


  const previous =
    notifications.value;


  notifications.value =
    notifications.value.filter(
      notification =>
        notification.id !== item.id
    );


  try {

    await NotificationService
      .deleteNotification(
        item.id
      );

  } catch (error) {

    console.error(
      "❌ Ошибка удаления уведомления:",
      error
    );


    notifications.value =
      previous;

  }

}


function handleNotificationClick(item) {

  const type =
    item?.type;


  console.log(
    "🛎️ Click notification:",
    {
      id: item?.id,
      type,
      created_at: item?.created_at,
      notification: item?.notification
    }
  );


  if (
    type === "new_response"
  ) {

    router.push(
      "/my-vacancies"
    );

    return;

  }


  if (
    type === "new_message" ||
    type === "new_chat"
  ) {

    router.push(
      "/dialogs"
    );

    return;

  }

}

</script>


<style scoped>

/* ============================================================
   DROPDOWN
============================================================ */

.notifications-dropdown {
  position: absolute;

  top: 56px;
  right: 60px;

  width: 360px;
  height: 400px;

  box-sizing: border-box;

  z-index: 9999;

  display: flex;
  flex-direction: column;

  overflow: hidden;

  color: #30353c;

  background:
    rgba(255, 255, 255, 0.985);

  border:
    1px solid
    rgba(30, 45, 65, 0.07);

  border-radius:
    20px;

  box-shadow:
    0
    22px
    55px
    rgba(15, 23, 42, 0.16);

  backdrop-filter:
    blur(18px)
    saturate(130%);

  -webkit-backdrop-filter:
    blur(18px)
    saturate(130%);

  transform-origin:
    top right;

  animation:
    notificationDropdownAppear
    .22s
    cubic-bezier(.22, 1, .36, 1);
}


/* ============================================================
   HEADER
============================================================ */

.dropdown-header {
  flex:
    0
    0
    auto;

  min-height:
    72px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  box-sizing: border-box;

  padding:
    15px
    17px;

  border-bottom:
    1px solid
    rgba(35, 50, 70, 0.055);
}


.header-title-row {
  display: flex;
  align-items: center;

  gap: 10px;
}


.header-icon {
  width: 34px;
  height: 34px;

  flex:
    0
    0
    34px;

  display: flex;
  align-items: center;
  justify-content: center;

  color:
    #527eaf;

  background:
    rgba(65, 115, 180, 0.08);

  border:
    1px solid
    rgba(70, 120, 185, 0.075);

  border-radius:
    10px;
}


.header-icon svg {
  width: 17px;
  height: 17px;
}


.header-title {
  margin: 0;

  color:
    #30353c;

  font-family:
    "Eastman-Bold",
    sans-serif;

  font-size:
    13px;

  line-height:
    1.2;

  letter-spacing:
    -0.2px;
}


.header-subtitle {
  margin:
    3px
    0
    0;

  color:
    #9298a0;

  font-family:
    "Eastman-Regular",
    sans-serif;

  font-size:
    8px;

  line-height:
    1.3;
}


/* ============================================================
   COUNT
============================================================ */

.notification-count {
  min-width: 23px;
  height: 23px;

  display: flex;
  align-items: center;
  justify-content: center;

  box-sizing: border-box;

  padding:
    0
    6px;

  color:
    #5279aa;

  background:
    rgba(65, 115, 180, 0.08);

  border:
    1px solid
    rgba(65, 115, 180, 0.08);

  border-radius:
    8px;

  font-family:
    "Eastman-Medium",
    sans-serif;

  font-size:
    9px;
}


/* ============================================================
   CONTENT
============================================================ */

.dropdown-content {
  min-height: 0;

  flex: 1;

  overflow-y: auto;

  padding:
    8px;

  scrollbar-width:
    none;

  overscroll-behavior:
    contain;
}


.dropdown-content::-webkit-scrollbar {
  display: none;
}


/* ============================================================
   SKELETON
============================================================ */

.skeleton-list {
  padding:
    4px;
}


.notification-skeleton {
  margin-bottom:
    8px;
}


/* ============================================================
   LIST
============================================================ */

.notifications-list {
  display: flex;
  flex-direction: column;

  gap: 4px;
}


/* ============================================================
   NOTIFICATION
============================================================ */

.notification-item {
  position: relative;

  min-height: 67px;

  display: flex;
  align-items: center;

  gap: 10px;

  box-sizing: border-box;

  padding:
    9px
    9px;

  overflow: hidden;

  background:
    transparent;

  border:
    1px solid
    transparent;

  border-radius:
    13px;

  cursor:
    pointer;

  opacity:
    0;

  transform:
    translateY(7px);

  animation:
    itemAppear
    .28s
    forwards;

  transition:
    background-color .18s ease,
    border-color .18s ease,
    transform .18s ease;
}


.notification-item:hover {
  background:
    #f6f8fa;

  border-color:
    rgba(35, 55, 80, 0.045);
}


.notification-item:active {
  transform:
    scale(.992);
}


/* ============================================================
   ICON WRAPPER
============================================================ */

.notification-icon-wrap {
  width: 40px;
  height: 40px;

  flex:
    0
    0
    40px;

  display: flex;
  align-items: center;
  justify-content: center;

  box-sizing: border-box;

  background:
    #f2f5f8;

  border:
    1px solid
    rgba(35, 55, 80, 0.045);

  border-radius:
    12px;
}


.notification-icon {
  width: 25px;
  height: 25px;

  display: block;

  object-fit:
    contain;
}


/* Можно чуть различать типы */

.notification-icon-wrap.type-friend_request,
.notification-icon-wrap.type-friend_accept {
  background:
    rgba(65, 145, 105, 0.07);
}


.notification-icon-wrap.type-new_chat,
.notification-icon-wrap.type-new_message {
  background:
    rgba(60, 120, 200, 0.07);
}


.notification-icon-wrap.type-chat_gpt {
  background:
    rgba(120, 90, 180, 0.07);
}


.notification-icon-wrap.type-new_vacancy,
.notification-icon-wrap.type-new_response,
.notification-icon-wrap.type-weekly_newsletter {
  background:
    rgba(65, 115, 180, 0.07);
}


/* ============================================================
   CONTENT
============================================================ */

.notification-content {
  min-width: 0;

  flex: 1;
}


.notification-top-row {
  display: flex;
  align-items: center;
  justify-content: space-between;

  gap: 8px;
}


.notification-title {
  min-width: 0;

  margin: 0;

  overflow: hidden;

  color:
    #444b54;

  font-family:
    "Eastman-Medium",
    sans-serif;

  font-size:
    10px;

  line-height:
    1.25;

  white-space:
    nowrap;

  text-overflow:
    ellipsis;
}


.notification-date {
  flex-shrink: 0;

  color:
    #a3a8af;

  font-family:
    "Eastman-Regular",
    sans-serif;

  font-size:
    8px;

  white-space:
    nowrap;
}


.notification-description {
  margin:
    4px
    0
    0;

  overflow:
    hidden;

  color:
    #818892;

  font-family:
    "Eastman-Regular",
    sans-serif;

  font-size:
    9px;

  line-height:
    1.35;

  display:
    -webkit-box;

  -webkit-line-clamp:
    2;

  -webkit-box-orient:
    vertical;
}


/* ============================================================
   DELETE
============================================================ */

.delete-notification-button {
  width: 27px;
  height: 27px;

  flex:
    0
    0
    27px;

  display: flex;
  align-items: center;
  justify-content: center;

  padding: 0;

  color:
    #a0a6ad;

  background:
    transparent;

  border:
    none;

  border-radius:
    8px;

  cursor:
    pointer;

  opacity:
    0;

  transform:
    translateX(3px);

  transition:
    opacity .18s ease,
    transform .18s ease,
    color .18s ease,
    background-color .18s ease;
}


.delete-notification-button svg {
  width: 14px;
  height: 14px;
}


.notification-item:hover
.delete-notification-button {
  opacity:
    1;

  transform:
    translateX(0);
}


.delete-notification-button:hover {
  color:
    #c66464;

  background:
    rgba(190, 80, 80, 0.07);
}


/* ============================================================
   EMPTY
============================================================ */

.empty-state {
  height: 100%;

  min-height: 270px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  box-sizing: border-box;

  padding:
    20px;
}


.empty-icon-wrap {
  width: 64px;
  height: 64px;

  display: flex;
  align-items: center;
  justify-content: center;

  background:
    #f5f7f9;

  border:
    1px solid
    rgba(35, 50, 70, 0.05);

  border-radius:
    19px;
}


.empty-icon {
  width: 42px;
  height: 42px;

  object-fit:
    contain;

  opacity:
    .76;
}


.empty-title {
  margin-top:
    13px;

  color:
    #555d66;

  font-family:
    "Eastman-Medium",
    sans-serif;

  font-size:
    11px;
}


.empty-text {
  margin:
    5px
    0
    0;

  color:
    #989ea6;

  font-family:
    "Eastman-Regular",
    sans-serif;

  font-size:
    9px;

  text-align:
    center;
}


/* ============================================================
   DARK
============================================================ */

html[data-theme="dark"]
.notifications-dropdown {
  color:
    #e8eaed;

  background:
    linear-gradient(
      145deg,
      rgba(34, 36, 42, .985),
      rgba(29, 31, 36, .985)
    );

  border-color:
    rgba(255, 255, 255, .065);

  box-shadow:
    0
    24px
    60px
    rgba(0, 0, 0, .34);
}


html[data-theme="dark"]
.dropdown-header {
  border-color:
    rgba(255, 255, 255, .055);
}


html[data-theme="dark"]
.header-icon {
  color:
    #91b6ee;

  background:
    rgba(90, 135, 195, .09);

  border-color:
    rgba(115, 155, 210, .08);
}


html[data-theme="dark"]
.header-title {
  color:
    #f0f1f3;
}


html[data-theme="dark"]
.header-subtitle {
  color:
    #747a83;
}


html[data-theme="dark"]
.notification-count {
  color:
    #a7c5ed;

  background:
    rgba(90, 140, 205, .08);

  border-color:
    rgba(110, 155, 215, .09);
}


html[data-theme="dark"]
.notification-item:hover {
  background:
    rgba(255, 255, 255, .035);

  border-color:
    rgba(255, 255, 255, .045);
}


html[data-theme="dark"]
.notification-icon-wrap {
  background:
    rgba(255, 255, 255, .035);

  border-color:
    rgba(255, 255, 255, .045);
}


html[data-theme="dark"]
.notification-icon-wrap.type-friend_request,
html[data-theme="dark"]
.notification-icon-wrap.type-friend_accept {
  background:
    rgba(75, 150, 110, .07);
}


html[data-theme="dark"]
.notification-icon-wrap.type-new_chat,
html[data-theme="dark"]
.notification-icon-wrap.type-new_message {
  background:
    rgba(80, 135, 205, .075);
}


html[data-theme="dark"]
.notification-icon-wrap.type-chat_gpt {
  background:
    rgba(125, 95, 180, .075);
}


html[data-theme="dark"]
.notification-icon-wrap.type-new_vacancy,
html[data-theme="dark"]
.notification-icon-wrap.type-new_response,
html[data-theme="dark"]
.notification-icon-wrap.type-weekly_newsletter {
  background:
    rgba(85, 125, 180, .075);
}


html[data-theme="dark"]
.notification-title {
  color:
    #d9dde2;
}


html[data-theme="dark"]
.notification-date {
  color:
    #666d76;
}


html[data-theme="dark"]
.notification-description {
  color:
    #858b94;
}


html[data-theme="dark"]
.delete-notification-button {
  color:
    #666d75;
}


html[data-theme="dark"]
.delete-notification-button:hover {
  color:
    #d18a8a;

  background:
    rgba(195, 85, 85, .07);
}


html[data-theme="dark"]
.empty-icon-wrap {
  background:
    rgba(255, 255, 255, .025);

  border-color:
    rgba(255, 255, 255, .05);
}


html[data-theme="dark"]
.empty-title {
  color:
    #c6cad0;
}


html[data-theme="dark"]
.empty-text {
  color:
    #727881;
}


/* ============================================================
   ANIMATION
============================================================ */

@keyframes notificationDropdownAppear {

  0% {
    opacity: 0;

    transform:
      translateY(-8px)
      scale(.975);
  }


  100% {
    opacity: 1;

    transform:
      translateY(0)
      scale(1);
  }

}


.notification-item:nth-child(1) {
  animation-delay: .025s;
}

.notification-item:nth-child(2) {
  animation-delay: .05s;
}

.notification-item:nth-child(3) {
  animation-delay: .075s;
}

.notification-item:nth-child(4) {
  animation-delay: .10s;
}

.notification-item:nth-child(5) {
  animation-delay: .125s;
}

.notification-item:nth-child(6) {
  animation-delay: .15s;
}

.notification-item:nth-child(7) {
  animation-delay: .175s;
}

.notification-item:nth-child(8) {
  animation-delay: .20s;
}


@keyframes itemAppear {

  to {
    opacity: 1;

    transform:
      translateY(0);
  }

}


/* ============================================================
   MOBILE
============================================================ */

@media (max-width: 768px) {

  .notifications-dropdown {
    position:
      fixed;

    top:
      76px;

    left:
      12px;

    right:
      12px;

    width:
      auto;

    height:
      auto;

    max-height:
      70vh;

    border-radius:
      22px;
  }


  .dropdown-header {
    min-height:
      68px;

    padding:
      14px;
  }


  .header-title {
    font-size:
      13px;
  }


  .dropdown-content {
    padding:
      7px;
  }


  .notification-item {
    min-height:
      64px;

    padding:
      9px;
  }


  .notification-icon-wrap {
    width:
      38px;

    height:
      38px;

    flex-basis:
      38px;
  }


  .notification-icon {
    width:
      23px;

    height:
      23px;
  }


  .notification-title {
    font-size:
      10px;
  }


  .notification-description {
    font-size:
      9px;
  }


  .delete-notification-button {
    opacity:
      1;

    transform:
      none;
  }

}


/* ============================================================
   REDUCED MOTION
============================================================ */

@media (prefers-reduced-motion: reduce) {

  .notifications-dropdown,
  .notification-item {
    animation:
      none;

    opacity:
      1;

    transform:
      none;
  }


  .notification-item,
  .delete-notification-button {
    transition:
      none;
  }

}

</style>